import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import translation files
import enCommon from './locales/en/common.json';
import enPatientInfo from './locales/en/patientInfo.json';
import enInsurance from './locales/en/insurance.json';
import enMedicalHistory from './locales/en/medicalHistory.json';
import enOtherHistory from './locales/en/otherHistory.json';
import enConcerns from './locales/en/concerns.json';
import enTreatmentConsents from './locales/en/treatmentConsents.json';
import enMedicalRecordsRelease from './locales/en/medicalRecordsRelease.json';
import enSelfPayPolicy from './locales/en/selfPayPolicy.json';

import esCommon from './locales/es/common.json';
import esPatientInfo from './locales/es/patientInfo.json';
import esInsurance from './locales/es/insurance.json';
import esMedicalHistory from './locales/es/medicalHistory.json';
import esOtherHistory from './locales/es/otherHistory.json';
import esConcerns from './locales/es/concerns.json';
import esTreatmentConsents from './locales/es/treatmentConsents.json';
import esMedicalRecordsRelease from './locales/es/medicalRecordsRelease.json';
import esSelfPayPolicy from './locales/es/selfPayPolicy.json';

const resources = {
  en: {
    common: enCommon,
    patientInfo: enPatientInfo,
    insurance: enInsurance,
    medicalHistory: enMedicalHistory,
    otherHistory: enOtherHistory,
    concerns: enConcerns,
    treatmentConsents: enTreatmentConsents,
    medicalRecordsRelease: enMedicalRecordsRelease,
    selfPayPolicy: enSelfPayPolicy,
  },
  es: {
    common: esCommon,
    patientInfo: esPatientInfo,
    insurance: esInsurance,
    medicalHistory: esMedicalHistory,
    otherHistory: esOtherHistory,
    concerns: esConcerns,
    treatmentConsents: esTreatmentConsents,
    medicalRecordsRelease: esMedicalRecordsRelease,
    selfPayPolicy: esSelfPayPolicy,
  },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    defaultNS: 'common',
    ns: ['common', 'patientInfo', 'insurance', 'medicalHistory', 'otherHistory', 'concerns', 'treatmentConsents', 'medicalRecordsRelease', 'selfPayPolicy'],
    
    detection: {
      order: ['querystring', 'localStorage', 'navigator'],
      lookupQuerystring: 'lang',
      lookupLocalStorage: 'i18nextLng',
      caches: ['localStorage'],
    },

    interpolation: {
      escapeValue: false, // React already escapes values
    },
  });

export default i18n;
